import type { SubscriptionType } from "@vellum/vellum-api";

/** Hidden send_delay_days sent with each subscription, per report type. */
export const SEND_DELAY_DAYS: Record<SubscriptionType, number> = {
  Daily: 1,
  Weekly: 7,
};

/** All subscription send times are US Central Time. */
export function formatSendHourCT(hour: number): string {
  const twelveHour = hour % 12 === 0 ? 12 : hour % 12;
  const meridiem = hour < 12 ? "AM" : "PM";
  return `${twelveHour}:00 ${meridiem} CT`;
}
